<template>
  <div>
    <div class="layout">
      <div class="align-between">
        <!-- <h2 class="title" style="width:auto">{{this.subjectNm}}</h2> -->

        <div class="title-select-wrap">
          <button type="button" class="title" ref="subMenuTitle" @click="eventClickSubMenu($event.target)">‘통계표’ Open API</button>
          <div ref="subMenuItem">
            <ul class="subGnb-depth03 title-menu">
              <li>
                <router-link :to="{name: 'Open API'}">‘통계표’ Open API</router-link>
              </li>
              <li>
                <router-link :to="{name: 'MDSS Open API'}">‘MDSS’ Open API</router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="layout">
      <div class="api-section">
          <div class="space-bet">
          <h3 class="tit-api">서비스 개요</h3>
          </div>
        <div class="tb-scroll">
          <table class="pur-table">
            <caption>서비스 개요</caption>
            <colgroup>
              <col style="width: 12%;">
              <col style="width: 13%;">
              <col>
            </colgroup>
            <tbody>
              <tr>
                <th rowspan="3">서비스 정보</th>
                <th>서비스명(국문)</th>
                <td class="txt-left">MDSS 조회 서비스</td>
              </tr>
              <tr>
                <th>서비스명(영문)</th>
                <td class="txt-left">mdssReferenceService</td>
              </tr>
              <tr>
                <th>서비스 설명</th>
                <td class="txt-left">문화셈터에서 제공중인 MDSS를 조회하는 서비스입니다.</td>
              </tr>
              <tr>
                <th rowspan="2">서비스 보안</th>
                <th>서비스 인증/권한</th>
                <td class="txt-left">서비스 Key</td>
              </tr>
              <tr>
                <th>전송 레벨 암호화</th>
                <td class="txt-left">없음</td>
              </tr>
              <tr>
                <th rowspan="2">적용 기술 수준</th>
                <th>인터페이스 표준</th>
                <td class="txt-left">REST (GET, POST, PUT, DELETE)</td>
              </tr>
              <tr>
                <th>교환 데이터 표준</th>
                <td class="txt-left">JSON</td>
              </tr>
              <tr>
                <th>서비스 URL</th>
                <th>운영환경</th>
                <td class="txt-left">http://stat.mcst.go.kr/portal/openapi/mdss/{오퍼레이션명(영문)}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="api-section">
        <div class="space-bet">
          <h3 class="tit-api">오퍼레이션 목록</h3>
        </div>
        <div class="tb-scroll">
          <table class="pur-table">
            <caption>오퍼레이션 목록</caption>
            <colgroup>
              <col style="width: 12%;">
              <col>
              <col>
              <col>
              <col>
            </colgroup>
            <thead>
              <tr>
                <th>일련번호</th>
                <th>서비스명(국문)</th>
                <th>오퍼레이션명(영문)</th>
                <th>오퍼레이션명(국문)</th>
                <th>메시지명(영문)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>MDSS 조회 서비스</td>
                <td>getArtclList</td>
                <td>항목조회</td>
                <td>N/A</td>
              </tr>
              <tr>
                <td>2</td>
                <td>MDSS 조회 서비스</td>
                <td>getDataList</td>
                <td>데이터조회</td>
                <td>N/A</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="api-section">
        <div class="space-bet">
          <h3 class="tit-api">항목조회 오퍼레이션 명세</h3>
        </div>
        <div class="tb-scroll">
          <table class="pur-table">
            <caption>항목조회 오퍼레이션 명세</caption>
            <colgroup>
              <col>
              <col style="width: 18%;">
              <col style="width: 24%;">
              <col style="width: 18%;">
              <col style="width: 24%;">
            </colgroup>
            <tbody>
              <tr>
                <th rowspan="4">오퍼레이션 정보</th>
                <th>오퍼레이션 번호</th>
                <td class="txt-left">1</td>
                <th>오퍼레이션명(국문)</th>
                <td class="txt-left">항목조회</td>
              </tr>
              <tr>
                <th>오퍼레이션 유형</th>
                <td class="txt-left">조회(목록)</td>
                <th>오퍼레이션명(영문)</th>
                <td class="txt-left">getArtclList</td>
              </tr>
              <tr>
                <th>오퍼레이션 설명</th>
                <td colspan="3" class="txt-left">문화셈터에서 제공중인 MDSS 중 항목 목록을 제공한다.</td>
              </tr>
              <tr>
                <th>Call Back URL</th>
                <td colspan="3" class="txt-left">N/A</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="api-section">
        <div class="space-bet">
          <h3 class="tit-api">요청 메시지 명세</h3>
          <p class="txt-str">※ 항목구분 : 필수(1), 옵션(0), 1건 이상 복수건(1..n), 0건 또는 복수건(0..n)</p>
        </div>
        <div class="tb-scroll">
          <table class="pur-table">
            <caption>요청 메시지 명세</caption>
            <thead>
              <tr>
                <th>항목명(영문)</th>
                <th>항목명(국문)</th>
                <th>항목크기</th>
                <th>항목구분</th>
                <th>샘플데이터</th>
                <th>항목설명</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>statsId</td>
                <td>통계분류ID</td>
                <td>20</td>
                <td>1</td>
                <td>325</td>
                <td>통계분류ID</td>
              </tr>
              <tr>
                <td>statsYr</td>
                <td>통계연도</td>
                <td>8</td>
                <td>1</td>
                <td>2023</td>
                <td>통계연도</td>
              </tr>
              <tr>
                <td>ctfcnVl</td>
                <td>인증값</td>
                <td>20</td>
                <td>1</td>
                <td>AD00BC12AAAD00BC12AA</td>
                <td>Open API 이용을 통해 발급된 인증값</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="api-section">
        <div class="space-bet">
          <h3 class="tit-api">응답 메시지 명세</h3>
          <p class="txt-str">※ 항목구분 : 필수(1), 옵션(0), 1건 이상 복수건(1..n), 0건 또는 복수건(0..n)</p>
        </div>
        <div class="tb-scroll">
          <table class="pur-table">
            <caption>응답 메시지 명세</caption>
            <thead>
              <tr>
                <th>항목명(영문)</th>
                <th>항목명(국문)</th>
                <th>항목크기</th>
                <th>항목구분</th>
                <th>샘플데이터</th>
                <th>항목설명</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>artcId</td>
                <td>항목ID</td>
                <td>5</td>
                <td>1</td>
                <td>304</td>
                <td>항목ID</td>
              </tr>
              <tr>
                <td>artcNm</td>
                <td>항목명</td>
                <td>400</td>
                <td>1</td>
                <td>문8 공간 유지비 여부</td>
                <td>항목명</td>
              </tr>
              <tr>
                <td>vrblNm</td>
                <td>변수명</td>
                <td>100</td>
                <td>1</td>
                <td>Q10B1</td>
                <td>변수명</td>
              </tr>
              <tr>
                <td>cdVl</td>
                <td>코드값</td>
                <td>20</td>
                <td>0</td>
                <td>2</td>
                <td>코드값</td>
              </tr>
              <tr>
                <td>cdNm</td>
                <td>코드명</td>
                <td>100</td>
                <td>1</td>
                <td>야외 무대공간</td>
                <td>코드명</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="api-section">
        <div class="space-bet">
          <h3 class="tit-api">요청/응답 메시지 예제</h3>
        </div>
        <div class="tb-scroll">
          <table class="pur-table">
            <caption>요청/응답 메시지 예제 - REST(URL)</caption>
            <thead>
              <tr>
                <th>REST(URL)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="txt-left">http://stat.mcst.go.kr/portal/openapi/mdss/getArtclList?statsId=246&statsYr=2023&ctfcnVl=AD00BC12AAAD00BC12AA</td>
              </tr>
            </tbody>
          </table>
          <table class="pur-table">
            <caption>요청/응답 메시지 예제 - 응답 메시지</caption>
            <thead>
              <tr>
                <th>응답 메시지</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="txt-left">
                  <pre>
                    <code>
                      {
                        "rspnsRslt": {
                            "rspnsCd": "0",
                            "rspnsMsg": "NORMAL_SERVICE",
                            "rspnsData": [
                                {
                                    "artcId": "2",
                                    "artcNm": "시설특성_코드",
                                    "vrblNm": "FAC1",
                                    "cdVl": "1",
                                    "cdNm": "중앙정부"
                                },
                                {
                                    "artcId": "2",
                                    "artcNm": "시설특성_코드",
                                    "vrblNm": "FAC1",
                                    "cdVl": "2",
                                    "cdNm": "문예회관"
                                },
                                {
                                    "artcId": "3",
                                    "artcNm": "공공코드",
                                    "vrblNm": "FAC2",
                                    "cdVl": "1",
                                    "cdNm": "공공"
                                },
                                {
                                    "artcId": "3",
                                    "artcNm": "공공코드",
                                    "vrblNm": "FAC2",
                                    "cdVl": "2",
                                    "cdNm": "민간"
                                },
                                ...
                                ...
                            ]
                        }
                    }
                    </code>
                  </pre>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="api-section">
        <div class="space-bet">
          <h3 class="tit-api">데이터조회 오퍼레이션 명세</h3>
        </div>
        <div class="tb-scroll">
          <table class="pur-table">
            <caption>데이터조회 오퍼레이션 명세</caption>
            <colgroup>
              <col>
              <col style="width: 18%;">
              <col style="width: 24%;">
              <col style="width: 18%;">
              <col style="width: 24%;">
            </colgroup>
            <tbody>
              <tr>
                <th rowspan="4">오퍼레이션 정보</th>
                <th>오퍼레이션 번호</th>
                <td class="txt-left">2</td>
                <th>오퍼레이션명(국문)</th>
                <td class="txt-left">데이터조회</td>
              </tr>
              <tr>
                <th>오퍼레이션 유형</th>
                <td class="txt-left">조회(목록)</td>
                <th>오퍼레이션명(영문)</th>
                <td class="txt-left">getDataList</td>
              </tr>
              <tr>
                <th>오퍼레이션 설명</th>
                <td colspan="3" class="txt-left">문화셈터에서 제공중인 MDSS 중 데이터 목록을 제공한다.</td>
              </tr>
              <tr>
                <th>Call Back URL</th>
                <td colspan="3" class="txt-left">N/A</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="api-section">
        <div class="space-bet">
          <h3 class="tit-api">요청 메시지 명세</h3>
          <p class="txt-str">※ 항목구분 : 필수(1), 옵션(0), 1건 이상 복수건(1..n), 0건 또는 복수건(0..n)</p>
        </div>
        <div class="tb-scroll">
          <table class="pur-table">
            <caption>요청 메시지 명세</caption>
            <thead>
              <tr>
                <th>항목명(영문)</th>
                <th>항목명(국문)</th>
                <th>항목크기</th>
                <th>항목구분</th>
                <th>샘플데이터</th>
                <th>항목설명</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>statsId</td>
                <td>통계분류ID</td>
                <td>20</td>
                <td>1</td>
                <td>325</td>
                <td>통계분류ID</td>
              </tr>
              <tr>
                <td>statsYr</td>
                <td>통계연도</td>
                <td>8</td>
                <td>1</td>
                <td>2023</td>
                <td>통계연도</td>
              </tr>
              <tr>
                <td>ctfcnVl</td>
                <td>인증값</td>
                <td>20</td>
                <td>1</td>
                <td>AD00BC12AAAD00BC12AA</td>
                <td>Open API 이용을 통해 발급된 인증값</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="api-section">
        <div class="space-bet">
          <h3 class="tit-api">응답 메시지 명세</h3>
          <p class="txt-str">※ 항목구분 : 필수(1), 옵션(0), 1건 이상 복수건(1..n), 0건 또는 복수건(0..n)</p>
        </div>
        <div class="tb-scroll">
          <table class="pur-table">
            <caption>응답 메시지 명세</caption>
            <thead>
              <tr>
                <th>항목명(영문)</th>
                <th>항목명(국문)</th>
                <th>항목크기</th>
                <th>항목구분</th>
                <th>샘플데이터</th>
                <th>항목설명</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{변수명}</td>
                <td>변수명</td>
                <td>500</td>
                <td>1</td>
                <td>0.273180398235294</td>
                <td>항목조회의 변수명,<br>통계분류에 따라 항목명(영문)이 변경 됨</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="api-section">
        <div class="space-bet">
          <h3 class="tit-api">요청/응답 메시지 예제</h3>
        </div>
        <div class="tb-scroll">
          <table class="pur-table">
            <caption>요청/응답 메시지 예제 - REST(URL)</caption>
            <thead>
              <tr>
                <th>REST(URL)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="txt-left">http://stat.mcst.go.kr/portal/openapi/mdss/getDataList?statsId=246&statsYr=2023&ctfcnVl=AD00BC12AAAD00BC12AA</td>
              </tr>
            </tbody>
          </table>
          <table class="pur-table">
            <caption>요청/응답 메시지 예제 - 응답 메시지</caption>
            <thead>
              <tr>
                <th>응답 메시지</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="txt-left">
                  <pre>
                    <code>
                      {
                        "rspnsRslt": {
                            "rspnsCd": "0",
                            "rspnsMsg": "NORMAL_SERVICE",
                            "rspnsData": [
                                  {
                                      "FAC1": "1",
                                      "FAC2": "2",
                                      "FAC3": "0.273180398235294",
                                      ...
                                      ...
                                  },
                                  {
                                      "FAC1": "1",
                                      "FAC2": "2",
                                      "FAC3": "0.273180398235294",
                                      ...
                                      ...
                                  },
                                  {
                                      "FAC1": "1",
                                      "FAC2": "2",
                                      "FAC3": "0.273180398235294",
                                      ...
                                      ...
                                  },
                                  ...
                                  ...
                            ]
                        }
                    }
                    </code>
                  </pre>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="api-section">
        <div class="space-bet">
          <h3 class="tit-api">Open API 에러코드</h3>
        </div>
        <div class="tb-scroll">
          <table class="pur-table">
            <caption>Open API 에러코드</caption>
            <colgroup>
              <col style="width: 10%;">
              <col>
              <col>
            </colgroup>
            <thead>
              <tr>
                <th>에러코드</th>
                <th>에러메세지</th>
                <th>설명</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>0</td>
                <td class="txt-left">NORMAL_SERVICE</td>
                <td class="txt-left">정상</td>
              </tr>
              <tr>
                <td>1</td>
                <td class="txt-left">APPLICATION_ERROR</td>
                <td class="txt-left">어플리케이션 에러</td>
              </tr>
              <tr>
                <td>2</td>
                <td class="txt-left">DB_ERROR</td>
                <td class="txt-left">데이터베이스 에러</td>
              </tr>
              <tr>
                <td>3</td>
                <td class="txt-left">NODATA_ERROR</td>
                <td class="txt-left">데이터없음 에러</td>
              </tr>
              <tr>
                <td>4</td>
                <td class="txt-left">HTTP_ERROR</td>
                <td class="txt-left">HTTP 에러</td>
              </tr>
              <tr>
                <td>5</td>
                <td class="txt-left">SERVICETIMEOUT_ERROR</td>
                <td class="txt-left">서비스 연결실패 에러</td>
              </tr>
              <tr>
                <td>10</td>
                <td class="txt-left">INVALID_REQUEST_PARAMETER_ERROR</td>
                <td class="txt-left">잘못된 요청 파라메터 에러</td>
              </tr>
              <tr>
                <td>11</td>
                <td class="txt-left">NO_MANDATORY_REQUEST_PARAMETERS_ERROR</td>
                <td class="txt-left">필수요청 파라메터가 없음</td>
              </tr>
              <tr>
                <td>12</td>
                <td class="txt-left">NO_OPENAPI_SERVICE_ERROR</td>
                <td class="txt-left">해당 오픈API서비스가 없거나 폐기됨</td>
              </tr>
              <tr>
                <td>13</td>
                <td class="txt-left">LOWER_CLASSIFICATION_EXISTENCE</td>
                <td class="txt-left">하위 분류가 있음</td>
              </tr>
              <tr>
                <td>20</td>
                <td class="txt-left">SERVICE_ACCESS_DENIED_ERROR</td>
                <td class="txt-left">서비스 접근거부</td>
              </tr>
              <tr>
                <td>21</td>
                <td class="txt-left">TEMPORARILY_DISABLE_THE_SERVICEKEY_ERROR</td>
                <td class="txt-left">일시적으로 사용할 수 없는 서비스 키</td>
              </tr>
              <tr>
                <td>99</td>
                <td class="txt-left">UNKNOWN_ERROR</td>
                <td class="txt-left">기타에러</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'
  export default {
      name: 'StatsOpenApi',
      mounted() {
        const currentMenu = document.querySelector('.router-link-active').innerText
        document.querySelector('.title-select-wrap > button').textContent = currentMenu
      },
      methods: {
        eventClickSubMenu (target) {
          if (target) {
            const subMenuItemDiv = target.nextElementSibling
            if (subMenuItemDiv && subMenuItemDiv.children) {
              const subMenuItemUl = subMenuItemDiv.querySelector('.subGnb-depth03')
              if (subMenuItemUl.style.display === 'block') {
                $(subMenuItemDiv.children[0]).stop().slideUp()
              } else {
                $(subMenuItemDiv.children[0]).stop().slideDown()
              }
            }
          }
        },
      }
  }
</script>

<style scoped>

</style>
